import React, { useState } from 'react';
import './NewProject.css';

const NewProject = () => {
  const [createSOAPUser, setCreateSOAPUser] = useState(false);
  const [firstRuntime, setFirstRuntime] = useState(false);
  const [customerNameDetermined, setCustomerNameDetermined] = useState(false);
  const [createCallVariableGroups, setCreateCallVariableGroups] = useState(false);
  const [ttsPromptAcknowledged, setTTSPromptAcknowledged] = useState(false);
  const [templateAcknowledged, setTemplateAcknowledged] = useState(false);
  const [skillAcknowledged, setSkillAcknowledged] = useState(false);

  const isChecklistComplete = createSOAPUser && firstRuntime && customerNameDetermined && createCallVariableGroups && ttsPromptAcknowledged && templateAcknowledged && skillAcknowledged;

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    switch (name) {
      case 'createSOAPUser':
        setCreateSOAPUser(checked);
        break;
      case 'firstRuntime':
        setFirstRuntime(checked);
        break;
      case 'customerNameDetermined':
        setCustomerNameDetermined(checked);
        break;
      case 'createCallVariableGroups':
        setCreateCallVariableGroups(checked);
        break;
      case 'ttsPromptAcknowledged':
        setTTSPromptAcknowledged(checked);
        break;
      case 'templateAcknowledged':
        setTemplateAcknowledged(checked);
        break;
      case 'skillAcknowledged':
        setSkillAcknowledged(checked);
        break;
      default:
        break;
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const fileUrl = './mock-ddd.xlsm';
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = 'mock_ddd.xlsm';
    link.click();
  };

  return (
    <div className="technology-selector">
      <div className="container">
        <header className="selector-header">
          <h1>Five9 New Project Setup</h1>
          <p>Complete the setup checklist before downloading your template</p>
        </header>

        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          minHeight: '50vh',
          padding: '20px 0'
        }}>
          <div className="technology-card" style={{ 
            maxWidth: '700px',
            width: '100%',
            textAlign: 'left'
          }}>
            
            <div style={{
              backgroundColor: "#e2f0d9",
              border: "1px solid #c3e6cb",
              borderRadius: "8px",
              padding: "16px",
              marginBottom: "24px",
            }}>
              <p style={{ margin: "0 0 12px 0", fontWeight: "bold", color: "#155724" }}>
                Please follow the instructions below to ensure all necessary steps are completed before downloading the template.
              </p>
            </div>

            <div style={{ marginBottom: "24px" }}>
              <h3 style={{ color: "#333", marginBottom: "12px" }}>Setup Instructions:</h3>
              
              <div style={{
                backgroundColor: "#f8f9fa",
                border: "1px solid #dee2e6",
                borderRadius: "8px",
                padding: "16px",
                marginBottom: "16px"
              }}>
                <h4 style={{ margin: "0 0 8px 0", color: "#495057" }}>Step 1: Create Local Five9 User for SOAP Integration</h4>
                <p style={{ margin: "0 0 8px 0", fontSize: "14px" }}>To use the SOAP API, create a user with the appropriate permissions:</p>
                <ul style={{ margin: "0", paddingLeft: "20px", fontSize: "13px", lineHeight: "1.4" }}>
                  <li>Login to Instance → Right Click on Users → Click Add User</li>
                  <li>Fill in First Name (presidio), Last Name (api), Email, Username, and Password</li>
                  <li>Uncheck "User can change password"</li>
                  <li>Navigate to Roles Tab → Click Add → Select Administrator</li>
                  <li>Remove Agent role, confirm with Yes</li>
                  <li>Uncheck 'User can access Java VCC Administrator Application'</li>
                  <li>Check 'User can use Administrator Services' and "All Admin Permissions", then Save</li>
                </ul>
              </div>

              <div style={{
                backgroundColor: "#f8f9fa",
                border: "1px solid #dee2e6",
                borderRadius: "8px",
                padding: "16px",
                marginBottom: "16px"
              }}>
                <h4 style={{ margin: "0 0 8px 0", color: "#495057" }}>Step 2: Create Call Variable Groups</h4>
                <p style={{ margin: "0 0 8px 0", fontSize: "14px" }}>Login to Instance → Right Click on Call Variables → Click Add Call Variable Group:</p>
                <ul style={{ margin: "0", paddingLeft: "20px", fontSize: "13px", lineHeight: "1.4" }}>
                  <li>Create a group labeled "Presidio Custom Variables"</li>
                  <li>Create a group labeled "[Customer Name] Custom Variables"</li>
                </ul>
              </div>

              <div style={{
                backgroundColor: "#fff3cd",
                border: "1px solid #ffeaa7",
                borderRadius: "8px",
                padding: "16px",
                marginBottom: "20px"
              }}>
                <p style={{ margin: "0 0 8px 0", fontWeight: "bold" }}>
                  **After downloading, you may need to 'Trust the file' due to macros**
                </p>
                <ul style={{ margin: "0", paddingLeft: "20px", fontSize: "13px" }}>
                  <li><strong>Mac Users</strong>: No extra steps needed</li>
                  <li><strong>Windows Users</strong>: Right Click on File → Properties → Unblock</li>
                </ul>
                <img 
                  src="./unblock.png" 
                  alt="Trust file steps" 
                  style={{
                    width: "200px",
                    display: "block",
                    margin: "10px auto",
                    border: "1px solid #ddd",
                    borderRadius: "4px"
                  }}
                />
              </div>
            </div>

            <form onSubmit={handleSubmit}>
              <h3 style={{ color: "#333", marginBottom: "16px" }}>Pre-Download Checklist:</h3>
              
              <div style={{
                backgroundColor: "#f8f9fa",
                border: "1px solid #dee2e6",
                borderRadius: "8px",
                padding: "16px",
                marginBottom: "20px"
              }}>
                <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                  <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "14px", cursor: "pointer" }}>
                    <input 
                      type="checkbox" 
                      name="createSOAPUser" 
                      checked={createSOAPUser} 
                      onChange={handleCheckboxChange}
                      style={{ transform: "scale(1.1)" }}
                    />
                    <span>Create SOAP API User</span>
                  </label>
                  
                  <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "14px", cursor: "pointer" }}>
                    <input 
                      type="checkbox" 
                      name="firstRuntime" 
                      checked={firstRuntime} 
                      onChange={handleCheckboxChange}
                      style={{ transform: "scale(1.1)" }}
                    />
                    <span>First time running automation</span>
                  </label>
                  
                  <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "14px", cursor: "pointer" }}>
                    <input 
                      type="checkbox" 
                      name="customerNameDetermined" 
                      checked={customerNameDetermined} 
                      onChange={handleCheckboxChange}
                      style={{ transform: "scale(1.1)" }}
                    />
                    <span>Customer Name Determined</span>
                  </label>
                  
                  <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "14px", cursor: "pointer" }}>
                    <input 
                      type="checkbox" 
                      name="createCallVariableGroups" 
                      checked={createCallVariableGroups} 
                      onChange={handleCheckboxChange}
                      style={{ transform: "scale(1.1)" }}
                    />
                    <span>Create Call Variable Groups</span>
                  </label>
                  
                  <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "14px", cursor: "pointer" }}>
                    <input 
                      type="checkbox" 
                      name="ttsPromptAcknowledged" 
                      checked={ttsPromptAcknowledged} 
                      onChange={handleCheckboxChange}
                      style={{ transform: "scale(1.1)" }}
                    />
                    <span>Acknowledge TTS Prompts</span>
                  </label>
                  
                  <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "14px", cursor: "pointer" }}>
                    <input 
                      type="checkbox" 
                      name="templateAcknowledged" 
                      checked={templateAcknowledged} 
                      onChange={handleCheckboxChange}
                      style={{ transform: "scale(1.1)" }}
                    />
                    <span>Acknowledge template creation</span>
                  </label>
                  
                  <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "14px", cursor: "pointer" }}>
                    <input 
                      type="checkbox" 
                      name="skillAcknowledged" 
                      checked={skillAcknowledged} 
                      onChange={handleCheckboxChange}
                      style={{ transform: "scale(1.1)" }}
                    />
                    <span>Acknowledge skill creation limitations</span>
                  </label>
                </div>
              </div>

              <div style={{ textAlign: 'center' }}>
                <button 
                  type="submit" 
                  disabled={!isChecklistComplete}
                  className="select-btn"
                  style={{ 
                    width: '250px',
                    opacity: !isChecklistComplete ? 0.5 : 1,
                    cursor: !isChecklistComplete ? 'not-allowed' : 'pointer'
                  }}
                >
                  Download Template
                </button>
                
                {!isChecklistComplete && (
                  <p style={{ 
                    marginTop: '12px', 
                    fontSize: '13px', 
                    color: '#dc3545',
                    fontStyle: 'italic'
                  }}>
                    Please complete all checklist items to enable download
                  </p>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewProject;
